import React, { useState } from 'react'
import styled, { createGlobalStyle } from 'styled-components'
import { Modal } from 'react-responsive-modal'
import { scrollbarSize } from '../util/dom'
import { FaPlusCircle } from 'react-icons/fa'
import { useTranslation } from '../lib/i18n'

const scrollbarWidth = scrollbarSize()

const Button = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 0;
    background: none;
    border: none;
    cursor: pointer;
    color: ${({ theme }) => theme.palette.brand.pink};
    font-size: 14px;
    margin: 10px 0;

    &:hover {
        opacity: 0.8;
    }
`

const GlobalModalStyles = createGlobalStyle`
    .react-responsive-modal-custom-overlay {
        background: rgba(1, 1, 1, 0.7);
        animation-duration: 300ms !important;
    }

    .react-responsive-modal-custom-modal {
        border-radius: 6px;
        padding: 2rem;
    }

    .react-responsive-modal-closeButton {
        z-index: 10;

        &, &:active, &:focus {
            outline: none;
        }
    }

    /** Anything can use this class to fix its width when the modal is displayed */
    .react-responsive-modal-width-fix {
        width: calc(100% - ${scrollbarWidth}px);
    }
`

export default ({ children }) => {
    const [open, setOpen] = useState(false)
    const { t } = useTranslation(undefined, { keyPrefix: 'common' })

    return (
        <>
            <GlobalModalStyles />
            <Modal
                center
                classNames={{
                    overlay: 'react-responsive-modal-custom-overlay',
                    modal: 'react-responsive-modal-custom-modal'
                }}
                open={open}
                onClose={() => setOpen(false)}
            >
                {children}
            </Modal>
            <Button onClick={() => setOpen(!open)}>
                <FaPlusCircle /> {t('readMore')}
            </Button>
        </>
    )
}
